const axios = require('axios');

class AuthClient {
    constructor(basePath) {
        this.basePath = basePath;
    }

    async request({
        path,
        method = 'get',
        body,
        query
    } = {}) {
        const response = await axios({
            url: this.basePath + path,
            method,
            params: query,
            data: body
        });
        return response.data;
    }

    async login(params) {
        const body = await this.request({
            path: '/login',
            method: 'post',
            body: params,
        });
        return body.result;
    }
}

module.exports = AuthClient;
